import React from "react";
import { IonCard, IonProgressBar } from "@ionic/react";
import TherapyProgress from "./TherapyProgress";
import { RightArrowIcon } from "../../assets/icons";
import "./TherapyCard.css";
import "../../theme/variables.css";
import { TherapiesCardProps } from "./types";
import { useIonRouter } from "@ionic/react";
import useAuth from "../../hooks/useAuth"; // Assuming you have a user context or similar

const TherapiesCard: React.FC<TherapiesCardProps> = ({
  title,
  therapies,
  noDevicesPaired,
  onClick,
}) => {
  const router = useIonRouter();
  const { user } = useAuth(); // Get user from auth context

  return (
    <IonCard className="therapies-card" style={{ width: "96vw" }}>
      <div className="summary-title">
        <div className="card-title py-2">{title} </div>
        {onClick && (
          <div
            className={`arrow${noDevicesPaired ? " arrow-disabled" : ""}`}
            style={{
              filter: noDevicesPaired ? "grayscale(100%)" : "none",
              cursor: noDevicesPaired ? "not-allowed" : "pointer",
            }}
            onClick={
              noDevicesPaired
                ? undefined
                : onClick
                ? onClick
                : () =>
                    router.push(
                      `/activity/details/cough?profile_id=${user?.profile_id}`,
                    )
            }
          >
            {" "}
            <RightArrowIcon />{" "}
          </div>
        )}
      </div>
      {noDevicesPaired && (
        <div
          className="font-semibold text-black justify-center item-center mx-5 my-5 p-4 flex"
          style={{
            fontSize: window.innerWidth > 760 ? "1.25rem" : "1rem",
            alignItems: "baseline",
          }}
        >
          No linked BiWaze<sup>®</sup> systems.
        </div>
      )}
      {!noDevicesPaired &&
        therapies.map((therapy, index) => (
          <div className="therapy-item" key={index}>
            <div className="therapy-header">
              <div className={`therapy-pill ${therapy.className}`}>
                {therapy.name}
              </div>
              <div className="therapy-value">
                {therapy.value} {therapy.unit}
              </div>
            </div>
            <IonProgressBar
              style={
                therapy.name === "BiWaze® Cough"
                  ? ({
                      "--background": "#f5a623",
                      "--progress-background": "#f5a623",
                    } as React.CSSProperties)
                  : ({
                      "--background": "#3a7bd5",
                      "--progress-background": "#3a7bd5",
                    } as React.CSSProperties)
              }
              className={`${therapy.className}-progress`}
              value={therapy.progress}
            ></IonProgressBar>
            <div className="therapy-circles">
              {/* {JSON.stringify(therapy.therapiesPerDay)} */}
              {Array.from({
                length:
                  therapy.therapiesPerDay || +(therapy.completed?.length || 0),
              }).map((_, circleIndex) => {
                const adherenceScore = parseFloat(
                  therapy.adherenceScores?.[circleIndex]?.adherence_score ||
                    "0",
                );
                const isComplete = !!therapy.completed?.[circleIndex];
                const completedValue =
                  therapy.completed?.[circleIndex]?.value || "";
                let hhmm = "";
                const completedDateStr =
                  therapy.completed?.[circleIndex]?.start_timestamp || "";
                if (completedDateStr) {
                  let suffix = completedDateStr.slice(-2);
                  if (suffix === "AM") {
                    suffix = "am";
                  } else if (suffix === "PM") {
                    suffix = "pm";
                  }
                  hhmm = `${completedDateStr.slice(0, -3)}${suffix}`;
                }
                const completedDate = hhmm;

                return (
                  <TherapyProgress
                    progress={75}
                    key={circleIndex}
                    deviceName={therapy.name}
                    isComplete={isComplete}
                    innerValue={completedValue}
                    outerValue={completedDate}
                  />
                );
              })}
              {(therapy.completed?.length ?? 0) >
                (therapy.therapiesPerDay || 0) && (
                <div className="flex items-center justify-center mb-4">
                  <h3 className="text-xs font-bold text-gray-900">+more</h3>
                </div>
              )}
            </div>
          </div>
        ))}
    </IonCard>
  );
};

export default TherapiesCard;
